import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Grid,
    GridColumn,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    DataForm,
    TextBox,
    ColorPicker,
} from '../../components/Form';


import {
    Title,
    PanelBox,
} from '../../components/Display';
import { postData } from '../../Api';

export default function MembershipTransactionTypesEdit(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const [formTitle, setFormTitle] = useState(null);
    const [formColor, setFormColor] = useState(null);
    const handleCancel = async () => {
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    const handleSave = async () => {
        await postData('/api/panel/page/membership-transaction-types-edit/save-data', {
            id: allProps['membership-transaction-types-id'],
            title: formTitle,
            color: formColor,
        });
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    useEffect(() => {
        postData('/api/panel/page/membership-transaction-types-edit/form-data', {
            id: allProps['membership-transaction-types-id'],
        }).then((response) => {
            setFormTitle(response.data.title);
            setFormColor(response.data.color);
        });
    }, []);
    return (
        <PanelBox>
            <DataForm>
                <Title>ویرایش</Title>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox label={'عنوان'} value={formTitle} onChange={setFormTitle} />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <ColorPicker label={'رنگ'} value={formColor} onChange={setFormColor} />
                    </GridColumn>
                </Grid>
                <LeftComponents>
                                    <Button onClick={handleCancel}>انصراف</Button>
                <Button onClick={handleSave}>ذخیره</Button>
                </LeftComponents>
            </DataForm>
            {modal && modal}
        </PanelBox>
    );
}
